<template>
    <div class="out-container" :style="{height}">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="120">
            <Row :gutter="20">
                <Col span="20">
                    <FormItem label="银行账户" prop="floorIds">
                        <select-tree
                            style="width: 700px"
                            v-model="info.floorIds"
                            :list="parkList"
                            multiple
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20" style="margin-top: 40px">
                <Col span="24">
                    <FormItem label="支付宝账户" prop="floorIdsOther">
                        <select-tree
                            style="width: 700px"
                            readonly
                            :value="floorIdsOther"
                            :list="parkList"
                            multiple
                            placeholder
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div>
            <Button
                type="primary"
                @click="save"
                :loading="loading"
                class="btmBtn"
            >
                保存
            </Button>
        </div>
    </div>
</template>

<script>
import { assetsTreeList } from '@/api/assets'
import { setPayType, queryPayType } from '@/api/setting'
export default {
    data() {
        return {
            height: '360px',
            loading: true,
            info: {
                floorIds: '',
                rentPayType: '1',
            },
            parkList: [],
            floorList: [],
            floorIdsOther: '',
        }
    },

    components: {},

    computed: {
        ruleValidate() {
            return {}
        },
    },
    watch: {
        'info.floorIds'() {
            const otherList = this.floorList.filter(
                (v) => !this.info.floorIds.includes(v)
            )
            this.floorIdsOther = otherList.join(',')
        },
    },

    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.height = detector.windowHeight - 300 + 'px'
        })
    },

    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                assetsTreeList({ pageNo: 1, pageSize: 999, level: 2 }),
                queryPayType(),
            ])
                .then((args) => {
                    let [parkList, list] = args
                    this.parkList = this.fetchAssetsPark(parkList)
                    list = list.data.list
                    if (list.length) {
                        const item = list.find(
                            (v) => v.rentPayType === this.info.rentPayType
                        )
                        console.log({ item })
                        this.info.floorIds = item.floorIds
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // level 1-园区 2-楼栋 3-楼层
        fetchAssetsPark(res) {
            var list = res.data.list

            list.forEach((v) => {
                // 楼栋修改标题
                if (v.level === 2) {
                    const park = list.find((p) => p.id === v.pid)
                    v.name = park.name + v.name
                    this.floorList.push(v.id)
                }

                // 默认都展开
                v.expand = true
            })
            return list
        },
        save() {
            this.loading = true
            setPayType(this.info).then(() => {
                this.$Message.success(this.$t('tips.update.success'))
                this.fetch()
            })
        },
    },
}
</script>
<style lang="less" scoped>
.out-container {
    width: 850px;
    margin: 50px auto;
    height: 350px;
    position: relative;
    .btmBtn {
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        width: 100px;
    }
}
</style>
